module.exports = __webpack_public_path__ + "static/img/7.10ceeb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/7.png
// module id = O5Z+
// module chunks = 0